<script lang="ts" setup>
import { ObSpace, ObModal } from '../../components';
import { UiButton } from '../../components/ui-button';
import { ConfirmDialog } from './shared';
import { useConfirmDialog } from './use-confirm-dialog';

interface Props {
  dialog: ConfirmDialog;
}

const props = defineProps<Props>();

const { remove } = useConfirmDialog();

function cancel() {
  props.dialog.onCancel?.(props.dialog);
  remove(props.dialog.id);
}

function confirm() {
  props.dialog.onConfirm?.(props.dialog);
  remove(props.dialog.id);
}

function onBeforeDeactivate() {
  if (props.dialog.closeButton) {
    remove(props.dialog.id);
  } else {
    return false;
  }
}
</script>

<template>
  <ObModal
    active
    style="width: 480px"
    :title="props.dialog.title"
    :deactivate-on-overlay-click="false"
    :close-button="props.dialog.closeButton ?? false"
    :on-before-deactivate
  >
    <div class="text-body-1">
      <component :is="props.dialog.contentComponent" v-if="props.dialog.contentComponent" />
      <template v-else>{{ props.dialog.text }}</template>
    </div>
    <div class="v:mt-7">
      <ObSpace spacing="4" align-x="end">
        <UiButton variant="secondary" size="l" @click="cancel()">
          {{ props.dialog.cancelText }}
        </UiButton>
        <UiButton size="l" @click="confirm()">{{ props.dialog.confirmText }}</UiButton>
      </ObSpace>
    </div>
  </ObModal>
</template>
